// theme.js
import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    type: 'dark', // Set the theme type to dark
    primary: {
      main: '#90caf9', // Adjust the primary color as needed
    },
    secondary: {
      main: '#ffcc80', // Adjust the secondary color as needed
    },
    error: {
      main: '#f48fb1', // Adjust the error color as needed
    },
    warning: {
      main: '#ffee58', // Adjust the warning color as needed
    },
    info: {
      main: '#81d4fa', // Adjust the info color as needed
    },
    success: {
      main: '#4caf50', // Adjust the success color as needed
    },
    background: {
      default: '#000', // Set the default background color to black
    },
  },
});

export default darkTheme;